import { Typography, Flex } from "antd";
import { TitleCardsList } from "Components/SelectableCard/Title";

const WorkPermitOptions = [
  {
    title: "Yes",
  },
  {
    title: "No",
  },
  {
    title: "Not sure",
    value: "Maybe",
  },
];

export const WorkPermit = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start" style={{}}>
      <Title style={{ fontSize: "18px", textAlign: "left" }}>
        Early work opportunities?
      </Title>
      <Flex wrap>
        <TitleCardsList
          options={WorkPermitOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
